// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filming-consent-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  position: relative;
  width: 36px;
  height: 36px;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(245, 158, 11, 0.55);
  border-radius: 10px;
  background: rgba(245, 158, 11, 0.16);
  color: #fbbf24;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;
}

.filming-consent-icon:hover {
  background: rgba(245, 158, 11, 0.28);
  border-color: rgba(251, 191, 36, 0.85);
}

.filming-consent-icon:active {
  transform: scale(0.96);
}

.filming-consent-icon__count {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #f59e0b;
  color: #1c1917;
  font-size: 0.65rem;
  font-weight: 800;
  line-height: 16px;
  text-align: center;
}

.filming-consent-dialog__backdrop {
  position: fixed;
  inset: 0;
  z-index: 5200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right))
    max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left));
  background: rgba(15, 23, 42, 0.72);
  box-sizing: border-box;
}

.filming-consent-dialog {
  width: min(100%, 380px);
  padding: 16px 18px 14px;
  border-radius: 14px;
  background: #1e293b;
  border: 1px solid rgba(251, 191, 36, 0.35);
  color: #f8fafc;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.4);
}

.filming-consent-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.filming-consent-dialog__header h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #fbbf24;
}

.filming-consent-dialog__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: -4px -4px 0 0;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
  cursor: pointer;
}

.filming-consent-dialog__body {
  margin: 0 0 14px;
  font-size: 0.9rem;
  line-height: 1.45;
  color: rgba(248, 250, 252, 0.88);
}

.filming-consent-dialog__ok {
  width: 100%;
  padding: 10px 14px;
  border: none;
  border-radius: 10px;
  background: var(--lt-brand, #0877bc);
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/FilmingConsentBar.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,0CAA0C;EAC1C,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;+EAC6E;EAC7E,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".filming-consent-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  position: relative;\n  width: 36px;\n  height: 36px;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(245, 158, 11, 0.55);\n  border-radius: 10px;\n  background: rgba(245, 158, 11, 0.16);\n  color: #fbbf24;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;\n}\n\n.filming-consent-icon:hover {\n  background: rgba(245, 158, 11, 0.28);\n  border-color: rgba(251, 191, 36, 0.85);\n}\n\n.filming-consent-icon:active {\n  transform: scale(0.96);\n}\n\n.filming-consent-icon__count {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 8px;\n  background: #f59e0b;\n  color: #1c1917;\n  font-size: 0.65rem;\n  font-weight: 800;\n  line-height: 16px;\n  text-align: center;\n}\n\n.filming-consent-dialog__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 5200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right))\n    max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left));\n  background: rgba(15, 23, 42, 0.72);\n  box-sizing: border-box;\n}\n\n.filming-consent-dialog {\n  width: min(100%, 380px);\n  padding: 16px 18px 14px;\n  border-radius: 14px;\n  background: #1e293b;\n  border: 1px solid rgba(251, 191, 36, 0.35);\n  color: #f8fafc;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.4);\n}\n\n.filming-consent-dialog__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.filming-consent-dialog__header h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #fbbf24;\n}\n\n.filming-consent-dialog__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  margin: -4px -4px 0 0;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n  cursor: pointer;\n}\n\n.filming-consent-dialog__body {\n  margin: 0 0 14px;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: rgba(248, 250, 252, 0.88);\n}\n\n.filming-consent-dialog__ok {\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  border-radius: 10px;\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
